<div class="sort-dropdown-container">
  <!-- DESKTOP: Label + Select -->
  <div class="desktop-sort" *ngIf="!isMobile">
    <label class="sort-label">{{ placeholder }}</label>
    <p-select
      [options]="options"
      [ngModel]="getActiveControl().value"
      optionLabel="label"
      optionValue="value"
      placeholder="Select"
      class="sort-dropdown"
      appendTo="body"
      (onChange)="onSortChange($event)"
    ></p-select>
  </div>

  <!-- MOBILE: Sort Icon -->
  <div class="mobile-sort" *ngIf="isMobile">
    <button class="sort-btn" (click)="toggleDropdown()">
      <i class="pi pi-sort-alt"></i>
    </button>

    <p-select
      [options]="options"
      [ngModel]="getActiveControl().value"
      optionLabel="label"
      optionValue="value"
      appendTo="body"
      style="visibility: hidden; position: absolute; width: 0; height: 0"
      (onChange)="onSortChange($event)"
      #sortSelect
    ></p-select>
  </div>
</div>
